import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type SelectHintProps = {
  hint: TranslationKeys;
  className?: string;
};

const SelectHintComp: FC<SelectHintProps> = ({ hint, className }) => {
  const { t } = useTranslation();
  const hintKey = toRuntimeTranslationKey(hint);

  return <p className={twMerge('text-tertiary-600 first-letter:capitalize', className)}>{t(hintKey as any)}</p>;
};

export const SelectHint = memo(SelectHintComp);
